import { axiosPost } from '@/api/AxiosApi';

export type sendEmailProps = {
  email: string;
  lang?: 'KO' | 'EN';
};
export const sendEmail = async (aData: sendEmailProps) => {
  const { email, lang = 'KO' } = aData;
  const payload = {
    path: '/sendmail',
    body: {
      email,
      lang,
    },
  };
  const { data: re } = await axiosPost(payload);
  return re
};
